<template>
    <v-card icon="mdi-cog-box" color="primary">
        <v-data-table :items="serversList" :headers="headers" :loading="loading" item-key="id" class="elevation-1"
            :search="search" fixed-header>

            <template v-slot:top>
                <v-toolbar>
                    <v-toolbar-title>
                        <span class="ma-2">
                            {{ $t('lb_bbb_servers') }}
                        </span>
                    </v-toolbar-title>
                    <v-divider vertical></v-divider>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                @click="getServers">
                                <v-icon medium>mdi-refresh</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('refresh') }}
                        </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                @click="showFilter = !showFilter">
                                <v-icon medium>mdi-filter</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('filter') }}
                        </span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn text icon color="primary" dark class="mb-2" v-bind="attrs" v-on="on"
                                v-show="hasPermission('command_loadbalancer_add')" @click="showSelectBBBDialog">
                                <v-icon medium>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>
                            {{ $t('lb_bbb_servers_add') }}
                        </span>
                    </v-tooltip>
                </v-toolbar>
                <v-expand-transition>
                    <v-card class="ma-3 pa-3" outlined solo v-show="showFilter" dense>
                        <v-row dense flex>
                            <v-col cols="12" lg="12" md="4">
                                <v-text-field v-model="search" :label="$t('search')" outlined dense hide-details>
                                </v-text-field>

                            </v-col>
                        </v-row>
                    </v-card>
                </v-expand-transition>
            </template>
            <template v-slot:[`item.remove`]="{ item }">
                <v-btn class="ma-2" text icon color="primary" @click="showLbBBBRemoveAskDialog(item)"
                    :disabled="!hasPermission('command_loadbalancer_remove')">
                    <v-icon medium>mdi-delete</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`item.panic`]="{ item }">
                <v-btn class="ma-2" text icon color="primary" @click="showLbBBBPanicAskDialog(item)"
                    :disabled="!hasPermission('command_loadbalancer_panic')">
                    <v-icon medium>mdi-wall-fire</v-icon>
                </v-btn>
            </template>
            <template v-slot:[`item.online`]="{ item }">
                  <v-chip :color="item.online=='online' ? 'success' : 'error'">{{ $t(item.online) }}</v-chip>
            </template>  
            <template v-slot:[`item.state`]="{ item }">
                <template v-if="!hasPermission(['command_loadbalancer_enable', 'command_loadbalancer_disable'], 'or')">
                    <v-chip :color="item.state=='enabled' ? 'success' : (item.state=='cordon'? 'warning' : 'error')">{{ $t(item.state) }}</v-chip>
                </template>
                <v-edit-dialog :return-value.sync="item.status" @save="lbBBBUpdate(item)" large persistent
                    :cancel-text="$t('close')" :save-text="$t('save')" v-else>
                    <v-chip :color="item.state=='enabled' ? 'success' : (item.state=='cordon'? 'warning' : 'error')">{{ $t(item.state) }}</v-chip>
                    <template v-slot:input>
                        <v-select v-model="item.state" :label="$t('state')" :items="stateObject" item-text="title"
                            item-value="value">

                        </v-select>
                    </template>
                </v-edit-dialog>
            </template>
            <template v-slot:[`item.load_multiplier`]="{ item }">
                <template v-if="!hasPermission(['command_loadbalancer_enable', 'command_loadbalancer_disable'], 'or')">
                    {{ $t(item.load_multiplier) }}
                </template>
                <v-edit-dialog :return-value.sync="item.status" @save="lbBBBUpdate(item)" large persistent
                    :cancel-text="$t('close')" :save-text="$t('save')" v-else>
                    {{ $t(item.load_multiplier) }}
                    <v-icon color="primary">
                        mdi-pencil
                    </v-icon>
                    <template v-slot:input>
                        <v-text-field v-model="item.load_multiplier" :label="$t('bbb_load_multiplier')">

                        </v-text-field>
                    </template>
                </v-edit-dialog>
            </template>

        </v-data-table>
        <v-dialog v-model="lbBBBRemoveAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('lb_bbb_delete_ask', { server: selectedItem?.url }) }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="lbBBBAction(selectedItem, 'remove')">{{ $t('yes') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeLbBBBRemoveAskDialog">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="lbBBBPanicAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('lb_bbb_panic_ask', { server: selectedItem?.url }) }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="lbBBBAction(selectedItem, 'panic')">{{ $t('yes') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeLbBBBPanicAskDialog">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="addBBBToLbAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('lb_bbb_delete_ask', { server: selectedItem?.url }) }}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="lbBBBAction(selectedItem, 'remove')">{{ $t('yes') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="addBBBToLbAskDialog = false">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="selectBBBDialog" max-width="700" scrollable>
            <v-card>
                <v-card-title>{{ $t('select_bbb_servers') }}
                    <v-sheet class="ma-3 pa-3" outlined solo dense>
                        <v-row dense flex>
                            <v-col cols="12" lg="3" md="3">
                                <v-text-field v-model="serverDomainFilter" @keydown.enter="getBBBServers"
                                    :label="$t('domain')" outlined dense hide-details>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="3" md="3">
                                <v-text-field v-model="serverIpFilter" @keydown.enter="getBBBServers" :label="$t('ip')"
                                    outlined dense hide-details>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" lg="3" md="3">
                                <v-btn rounded @click="getBBBServers" color="primary">
                                    <v-icon>
                                        mdi-filter
                                    </v-icon>
                                    {{ $t('filter') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-sheet>
                </v-card-title>
                <v-card-text>
                    <v-data-table v-model="selectedBBBServers" :items="bbbServersList" :headers="bbbServersHeader"
                        :server-items-length="totalServers" :loading="bbbServersLoading" :options.sync="options"
                        :items-per-page="itemPerPage" :page="pageNumber" item-key="id" class="elevation-3 pa-2"
                        show-select disable-sort fixed-header>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" large text @click="addBBBToLoadbalancer">{{ $t('save') }}</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" large text @click="closeSelectBBBDialog">{{ $t('close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import permissions from '../mixins/permissions';

export default {
    name:'LB_BBB_V2',
    mixins: [permissions],
    props: ['data'],
    data() {
        return {
            headers: [
                { text: this.$t('id'), value: 'id' },
                { text: this.$t('bbb_url'), value: 'url' },
                { text: this.$t('bbb_load'), value: 'load' },
                { text: this.$t('bbb_load_multiplier'), value: 'load_multiplier' },
                { text: this.$t('bbb_secret'), value: 'secret' },
                { text: this.$t('online'), value: 'online' },
                { text: this.$t('state'), value: 'state' },
                { text: this.$t('remove'), value: 'remove' },
                { text: this.$t('panic'), value: 'panic' },
            ],
            serversList: [],
            loading: false,
            showFilter: false,
            search: '',
            serversStatusList: [],
            statusLoading: false,
            showStatusFilter: false,
            searchStatus: '',
            selectedItem: -1,
            stateObject: [
                { title: this.$t('enabled'), value: "enable" },
                { title: this.$t('disable'), value: "disable" },
                { title: this.$t('cordon'), value: "cordon" }
            ],
            lbBBBRemoveAskDialog: false,
            lbBBBPanicAskDialog: false,
            bbbServersHeader: [
                { value: "domain", text: this.$t('domain'), divider: true, align: 'd-none' },
                { value: "ip", text: this.$t('ip') },
            ],
            bbbServersList: [],
            rowsPerPageItems: "[10, 20,50,100]",
            bbbServersLoading: true,
            totalServers: 0,
            options: {},
            itemPerPage: 10,
            pageNumber: 1,
            startRow: 0,
            endRow: 10,
            selectBBBDialog: false,
            selectedBBBServers: [],
            addBBBToLbAskDialog: false,
            serverDomainFilter: '',
            serverIpFilter: '',
            tabs: 0,
            lb: {}
        }
    },
    watch: {
        options: {
            handler() {
                this.getBBBServers();
            },
            deep: true,
        }
    },
    created() {
        this.lbId = this.data.lbId;
    },
    methods: {
        getServers() {
            this.loading = true,
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/loadbalancer/" + this.lbId + "/servers",
                    method: "GET",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                }).then(response => {
                    const data = response.data
                    this.serversList = data.data;
                    this.loading = false;
                }).catch(error => {
                    console.log('Show error notification!', error.response.data.error);
                    this.$toasted.error(error.response.data.error);
                }
                ).finally(a => {
                    this.loading = false;
                });
        },
        showLbBBBRemoveAskDialog(item) {
            this.selectedItem = item;
            this.lbBBBRemoveAskDialog = true;
        },
        closeLbBBBRemoveAskDialog() {
            this.lbBBBRemoveAskDialog = false;
            this.selectedItem = null;
        },
        showLbBBBPanicAskDialog(item) {
            this.selectedItem = item;
            this.lbBBBPanicAskDialog = true;
        },
        closeLbBBBPanicAskDialog() {
            this.lbBBBPanicAskDialog = false;
            this.selectedItem = null;
        },
        lbBBBAction(item, task) {
            let payload = {};
            // payload['virtual_machine_ids'] = [{ vm_id: item.id }];
            if (task == 'remove') {
                this.closeLbBBBRemoveAskDialog();
            }
            if (task == 'panic') {
                this.closeLbBBBPanicAskDialog();
            }
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/loadbalancer/" + this.lbId + "/" + task + "/" + item.id,
                method: "POST",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
                // data: payload
            }).then(() => {
                this.$toasted.success(this.$t('lb_action_success', { server: item?.url, action: task }));
                this.getServers();

            }).catch(error => {
                console.log('Show error notification!', error.response.data.error);
                this.$toasted.error(error.response.data.error);
            }
            );
        },
        lbBBBUpdate(item) {
            let payload = {'state':item.state,'load_multiplier':item.load_multiplier};
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/loadbalancer/" + this.lbId + "/update/" + item.id,
                method: "POST",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
                data: payload
            }).then(() => {
                this.$toasted.success(this.$t('lb_action_success', { server: item?.url }));
                this.getServers();

            }).catch(error => {
                console.log('Show error notification!', error.response.data.error);
                this.$toasted.error(error.response.data.error);
                this.getServers();
            }
            );
        },
        showSelectBBBDialog() {
            this.selectBBBDialog = true;
        },
        closeSelectBBBDialog() {
            this.selectBBBDialog = false;
            this.selectedBBBServers = [];
        },
        addBBBToLoadbalancer() {
            this.addBBBToLoadbalancerLoading = true;
            let payload = {};
            this.selectedBBBServers.forEach(element => {

                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/loadbalancer/" + this.lbId + "/add/" + element.id,
                    method: "POST",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                }).then(() => {
                    this.$toasted.success(this.$t('lb_bbb_servers_added_success'));
                    this.addBBBToLoadbalancerLoading = false;
                    this.closeSelectBBBDialog();
                    this.getServers();

                }).catch(error => {
                    console.log('Show error notification!', error.response.data.error);
                    this.$toasted.error(error.response.data.error);
                }
                );
            });
        },
        getBBBServers() {
            const payload = { _startRow: 0, _endRow: 2000 };
            if (this.serverDomainFilter != "")
                payload["domain"] = this.serverDomainFilter;
            if (this.serverIpFilter != "")
                payload["ip"] = this.serverIpFilter;


            payload['service_name'] = 'bigbluebutton';


            this.bbbServersLoading = true,
                axios({
                    url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine",
                    method: "GET",
                    headers: {
                        Authorization: this.$store.get("login/token"),
                    },
                    params: payload,
                }).then(response => {
                    const data = response.data.response;
                    this.bbbServersList = data.data;
                    this.totalServers = data.totalRows;
                    this.bbbServersLoading = false;
                });
        },
        getLb() {
            axios({
                url: process.env.VUE_APP_BACKEND_URL + "/api/virtual_machine/get/" + this.lbId,
                method: "GET",
                headers: {
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.lb = response.data
                this.getServers();
            });
        }
    },
    mounted() {
        this.getLb();

    },
}
</script>